import MainScreen from './app/screens/main';
import PrivacyScreen from './app/screens/privacy';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';
import './app.css';

function App() {


  return (

     <Router>
      <div className="App">
        <div className="content">
          <Routes>
            <Route path="/" element={<MainScreen />} />
            <Route path="/privacy" element={<PrivacyScreen />} />
          </Routes>
        </div>
      </div>
    </Router>
  
    
  );
}

export default App;
